import { createApp } from 'vue'
import './style/index.less'
import App from './App.vue'
import '../utils/rem.js'
createApp(App).mount('#app')
